// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tFTsI","col":"styles_col__2nwMS"};